import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Wall } from 'types';

export const deleteWall = (wallId: number) => {
  return axios.delete(`/api/walls/${wallId}`);
};

type UseDeleteWallOptions = {
  config?: MutationConfig<typeof deleteWall>;
};

export const useDeleteWall = ({ config }: UseDeleteWallOptions) => {
  return useMutation({
    onMutate: async (deletedWallId: number) => {
      await queryClient.cancelQueries(['walls']);

      const previousWalls = queryClient.getQueryData<Wall[]>(['walls']);

      queryClient.setQueryData(
        ['walls'],
        previousWalls?.filter(
          (analyzerSwitch) => analyzerSwitch.id !== deletedWallId
        )
      );

      return { previousWalls };
    },
    onError: (_, __, context: any) => {
      if (context?.previousWalls) {
        queryClient.setQueryData(['walls'], context.previousWalls);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['walls']);
      queryClient.invalidateQueries(['folders']);
    },
    ...config,
    mutationFn: deleteWall,
  });
};
